import MRUAttachmentStore from './schema/MRUAttachmentStore';
import { createStore } from 'satcheljs';

const initialMRUAttachmentStore: MRUAttachmentStore = {
    attachments: [],
};

const getMRUAttachmentStore = createStore<MRUAttachmentStore>(
    'MRUAttachmentStore',
    initialMRUAttachmentStore
);

export default getMRUAttachmentStore;
